
export let tableLabels = [{
  label: '海报名称',
  value: 'name'
}, {
  label: '海报类型',
  value: 'poster_type'
}, {
  label: '申请人',
  value: 'applyUser.fullName'
}, {
  label: '创建时间',
  value: 'createTime_copy'
}]

export let tableLabelsOk = [...tableLabels, {
  label: '发布时间',
  value: 'publishTime_copy'
}, {
  label: '审批人',
  value: 'auditUser.fullName'
}, {
  label: '海报状态',
  value: 'status_copy'
}]
